import request from "@/utils/request";

let DataApi = {
  /*设备接口*/
  getIndex(data, errorback) {
    return request._postBody("/shop/device/device/index", data, errorback);
  }
};
export default DataApi;



// WEBPACK FOOTER //
// ./src/api/device.js